import { render } from "./aio-login-header.vue?vue&type=template&id=482976fe&scoped=true"
import script from "./aio-login-header.vue?vue&type=script&lang=js"
export * from "./aio-login-header.vue?vue&type=script&lang=js"

import "./aio-login-header.vue?vue&type=style&index=0&id=482976fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482976fe"]])

export default __exports__